import { render } from "./PromotionProductBindModal.vue?vue&type=template&id=d5cbb7d8&scoped=true"
import script from "./PromotionProductBindModal.vue?vue&type=script&lang=js"
export * from "./PromotionProductBindModal.vue?vue&type=script&lang=js"

import "./PromotionProductBindModal.vue?vue&type=style&index=0&id=d5cbb7d8&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cbb7d8"]])

export default __exports__